import { getCourseSlugParam, getTeacherSlugParam } from '../utils/courseSlug';

export const ROUTES = {
  HOME: '/',
  PRICING: '/price',
  FREE_COURSES: '/courses/free',
  NEW_COURSES: '/courses/new',
  COURSES_BROWSE: '/courses/browse',
  COURSE_DETAIL: (courseOrId, title) => `/courses/${getCourseSlugParam(courseOrId, title)}`,
  COURSE_PLAYLIST: (courseOrId, title) => `/courses/${getCourseSlugParam(courseOrId, title)}/play`,
  TEACHER_DETAIL: (teacherOrId, name) => `/teachers/${getTeacherSlugParam(teacherOrId, name)}`,
  PROFILE: '/profile',
  PROFILE_PLAN: '/profile/plan',
  PROFILE_PROGRESS: '/profile/progress',
  PROFILE_FAVORITES: '/profile/favorites',
  PROFILE_HELP: '/profile/help',
  CONTACT: '/contact',
  ABOUT_US: '/about-us',
  POLICY: (type) => `/policies/${type}`,
  PAYMENT_SUCCESS: '/payment/success',
  PAYMENT_FAILED: '/payment/failed',
  PAYMENT_CALLBACK: '/payment/callback',
  PAYMENT_PENDING: '/payment/pending',
};
